/* @flow */
import SchoolViewHeading from './SchoolViewHeading';

export default SchoolViewHeading;
